import degreesConfig from "@2u-landing-pages/constants/configs/degrees.json";

const programConfigs = degreesConfig.programs.gu;

export const gu = {
  slug: "gu",
  name: "Georgetown University",
  colors: {
    primary1: "#fff",
    text: "#000",
  },
  fonts: {
    base: "Georgia, serif",
    url: "",
  },
  programConfigs,
};

